// extracted by mini-css-extract-plugin
export default {"root":"_X5tL8","saveArea":"JjGlVi","save":"hgf2tK","selected":"apYoSI","disabled":"r_GMBn","mainCycleBox":"JhPX7h","title":"NL2Gy3","price":"oWmBz1","aMonth":"NmCSWA"};